// extracted by css-extract-rspack-plugin
export default {"scaledDown":"DFUOo"};